// src/sidebar/SidebarData.js
import {
  FiHome,
  FiInfo,
  FiMail,
  FiSettings,
} from "react-icons/fi";

export const SidebarData = [
  {
    title: "Home",
    path: "/",
    icon: <FiHome className="sidebar-icon" />,
  },
  {
    title: "About",
    path: "/about",
    icon: <FiInfo className="sidebar-icon" />,
  },
  {
    title: "Contact",
    path: "/contact",
    icon: <FiMail className="sidebar-icon" />,
  },
  {
    title: "Admin",
    path: "/admin",
    icon: <FiSettings className="sidebar-icon" />,
  },
];